export const ADD_COMMENT = `
  mutation addComment($input: CreateCommentInput!) {
    addComment(input: $input) {
      id
      createdAt
      likes
      message
      type
      userId
      user {
        id
        avatar
        rank
        username
      }
      receiver {
        id
        username
      }
      mentionedUsers {
        id
        username
      }
    }
  }
`;
